// extracted by mini-css-extract-plugin
export default {"noConnection":"noConnection__AEhKuL"};